import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
export default function useBootstrap() {
	Vue.use(BootstrapVue);
}
